import { useGetQueryParams } from '@cp/shared/queryParams';
import { PropsWithChildren, createContext, useContext } from 'react';
import { DealStatus } from '@common/model/deal';
import { ProcessingCounterViewModel, ProcessingCountersType } from '@common/model/processing';
import { adminProcessingApi } from 'src/entities/processing';
import { ProcessingAndReviewsMapper } from '../model/mapper';
import { ProcessingAndReviewsQueryParams } from './processingAndReviews';

const defaultCounter: ProcessingCounterViewModel = {
  count: 0,
};

const defaultCounters: Record<ProcessingCountersType, ProcessingCounterViewModel> = {
  [ProcessingCountersType.Accepted]: defaultCounter,
  [ProcessingCountersType.InProgress]: defaultCounter,
  [ProcessingCountersType.Completed]: defaultCounter,
  [ProcessingCountersType.Negotiation]: defaultCounter,
  [ProcessingCountersType.RejectedByClient]: defaultCounter,
  [ProcessingCountersType.RejectedByExpired]: defaultCounter,
};

interface IContext {
  counters: Record<DealStatus, ProcessingCounterViewModel>;
  refetch: () => void;
}

const Context = createContext<() => IContext>(() => {
  throw new Error('DealsCountersProvider not provided');
});

export const useProcessingCounters = () => {
  const c = useContext(Context);
  return c();
};

export const ProcessingCountersProvider = ({ children }: PropsWithChildren) => {
  const params = useGetQueryParams<ProcessingAndReviewsQueryParams>();
  const query = ProcessingAndReviewsMapper.toProcessingCountersQuery(params);

  const { data, refetch } = adminProcessingApi.endpoints.getProcessingCounters.useQuery(query, {
    refetchOnMountOrArgChange: true,
  });

  return (
    <Context.Provider
      value={() => ({
        counters: defaultCounters,
        ...(data || {}),
        refetch,
      })}
    >
      {children}
    </Context.Provider>
  );
};
